import { INVALIDATE_SUBCOUNTRY_DATA } from './actionTypes';

export const invalidateSubCountryData = () => ({ type: INVALIDATE_SUBCOUNTRY_DATA });
